/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const BillStatus = { thirtyDay: "BILLABLE", ninetyDay: "BILLABLE" };

export const AnticoagulantIcon = {
  FATINTSLASH: "faTintSlash",
  AACAPTTEXT: "aacAptText",
  FATINT: "faTint",
  FAHEARTBEAT: "faHeartbeat",
  FAEXCLAMATIONTRIANGLE: "faExclamationTriangle",
};

export const AnticoagulantText = {
  APT: "APT",
  LAAC: "LAAC",
};
